const styles = () => ({
  icon: {
    position: 'relative',
    marginRight: 6,
    flexShrink: 0,
  },

  segmentWithDestinationsIcon: {
    marginRight: 6,

    '& path:first-child': {
      fill: '#31D48B',
    },
  },
});

export default styles;
